import React, { Fragment } from "react";
import GroupBarchart from "../../../../d3Components/NewBarchart/GroupBarchart";
import ContainerDimensions from "react-container-dimensions";
import Legend from "../../../../d3Components/legend";
import SimpleTable from "../../common/simpleTable";
import WithCard from "../../../../common/withCard";

const CalenderYear = ({
  benchmark_name,
  typeName,
  display_orig_portfolio,
  model_name,
  data,
}) => {
  return (
    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
      <WithCard>
        <h4 className="text-uppercase bold">
          CALENDAR YEAR BACK-TESTED PERFORMANCE
        </h4>
        {data.length > 0 ? (
          <Fragment>
            <div style={{ overflowX: "auto" }}>
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    {width > 0 ? (
                      <Fragment>
                        <Legend
                          height={30}
                          width={width}
                          legend1={
                            display_orig_portfolio
                              ? `IQCIO Model ${model_name ? "+" : ""}`
                              : "Portfolio"
                          }
                          legend2={
                            display_orig_portfolio ? "Benchmark *" : typeName
                          }
                          legend3={
                            display_orig_portfolio ? "Original Portfolio" : null
                          }
                        />

                        <GroupBarchart
                          // width={600}
                          containerWidth={width}
                          height={300}
                          data={data}
                          targetDiv="backtestBarChart4"
                        />
                      </Fragment>
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            </div>
            <SimpleTable
              rowHead1={
                display_orig_portfolio
                  ? `IQCIO Model ${model_name ? "+" : ""}`
                  : "Portfolio"
              }
              rowHead2={display_orig_portfolio ? "Benchmark *" : "Benchmark"}
              rowHead3={display_orig_portfolio ? "Original Portfolio" : null}
              heading={data.map((d, i) => {
                return <td key={i}>{d.metric_name}</td>;
              })}
              Row1={data.map((d, i) => {
                return (
                  <td key={i}>{`${
                    d.portfolio === null || d.portfolio === 0
                      ? "-"
                      : d.portfolio
                      ? d.portfolio.toFixed(2) + "%"
                      : null
                  }`}</td>
                );
              })}
              Row2={data.map((d, i) => {
                return (
                  <td key={i}>{`${
                    d.benchmark === null || d.benchmark === 0
                      ? "-"
                      : d.benchmark
                      ? d.benchmark.toFixed(2) + "%"
                      : null
                  }`}</td>
                );
              })}
              Row3={data.map((d, i) => {
                return d["Original portfolio"] === 0 ? (
                  <td key={`op-${i}`}>-</td>
                ) : d["Original portfolio"] ? (
                  <td key={`Orig-${i}`}>
                    {`${d["Original portfolio"].toFixed(2)}%`}
                  </td>
                ) : null;
              })}
            />
            {benchmark_name && display_orig_portfolio ? (
              <div>
                <small>
                  <b>*</b>&nbsp; {benchmark_name}
                </small>
              </div>
            ) : null}
            {model_name ? (
              <div>
                <small>
                  <b>+</b>&nbsp; {model_name}
                </small>
              </div>
            ) : null}
          </Fragment>
        ) : null}
      </WithCard>
    </div>
  );
};
export default CalenderYear;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/yearlyPerformance/calendarYear.jsx